<template>
<v-dialog v-model="visible" persistent max-width="500px">
  <v-card>
  <v-card-text>
    <v-form ref="contractorCreationForm" v-model="isValid" v-show="visible">
      <v-text-field
        v-model="contractor.title"
        label="Title"
        :rules="maxRules"
        required
      ></v-text-field>
      <v-text-field
        v-model="contractor.address"
        label="Address"
        :rules="maxRules"
      ></v-text-field>
      <v-text-field
        v-model="contractor.phone"
        label="Phone"
        :rules="phoneRules"
      ></v-text-field>
      <v-text-field
        v-model="contractor.email"
        label="Email"
        :rules="emailRules"
      ></v-text-field>
      <v-text-field
        v-model="contractor.responsiblePerson"
        :rules="maxRules"
        label="Responsible Person"
      ></v-text-field>
      <v-select
        :items="availableContractorMaterials"
        v-model="contractor.materialTypeId"
        label="Material Type"
        item-value="id"
        item-text="title"
        required
      ></v-select>
      <v-alert
        :value="hasError"
        type="error"
        outline
      >
        {{ errorMessage }}
      </v-alert>
      <v-btn
        :disabled="!isValid"
        @click="handleOkClick"
      >
        Save
      </v-btn>
      <v-btn @click="handleCancelClick">Cancel</v-btn>
    </v-form>
    </v-card-text>
  </v-card>
</v-dialog>

</template>

<script>
import _ from 'lodash'
import {extractErrorToString} from '../../helpers/api'
import { mapState, mapActions } from 'vuex'
import {validateStringLength} from '../../helpers/validation'

const emptyContractor = {
  title: null,
  address: null,
  phone: null,
  email: null,
  responsiblePerson: null,
  materialTypeId: null
}

export default {
  name: 'contractor-form',
  props: {
    visible: {
      type: Boolean
    },
    selectedContractorItem: {
      type: Object
    }
  },
  data () {
    return {
      hasError: null,
      isValid: false,
      errorMessage: null,
      contractor: _.clone(emptyContractor),
      maxRules: [
        _.partial(validateStringLength, _, 254, 'The length should be no more than 254 characters')
      ],
      phoneRules: [
        _.partial(validateStringLength, _, 64, 'The length should be no more than 64 characters')
      ],
      emailRules: [
        _.partial(validateStringLength, _, 64, 'The length of the email should be no more than 64 characters'),
        function (value) {
          if (!value) {
            return true
          }
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      ],
    }
  },
  computed: {
    ...mapState({
      availableContractorMaterials: "availableContractorMaterials"
    })
  },
  watch: {
    visible: function(){
      if (this.visible && this.selectedContractorItem){
        this.contractor = _.clone(this.selectedContractorItem)
      }
    }
  },
  methods: {
    ...mapActions({
      contractorCreate: 'contractorCreate',
      contractorUpdate: 'contractorUpdate'
    }),
    async handleOkClick () {
      this.hasError = null
      this.errorMessage = null

      if (this.contractor.id){
        try {
          let updatedItem = await this.contractorUpdate(this.contractor)
          this.resetForm()
        } catch (e) {
          this.hasError = true
          this.errorMessage = extractErrorToString(e, 'Unable to update contractor')
        }

        return
      }

      try {
        await this.contractorCreate(this.contractor)
        this.resetForm()
      } catch (e) {
        this.hasError = true
        this.errorMessage = extractErrorToString(e, 'Unable to create contractor')
      }
    },
    handleCancelClick () {
      this.resetForm()
    },
    resetForm () {
      this.hasError = null
      this.errorMessage = null
      this.$refs.contractorCreationForm.reset()
      this.contractor = _.clone(emptyContractor)

      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/ContractorForm.vue